import { transitionPersonalAccidentSpouseDetailsForm } from '../../../actions/afyaImara/spouseDetails';
import { getSpouseDetailsForm } from '../../../selectors/afyaImara/spouseDetails';

import { FIELD_STATUS } from '../../../reducers/status';

export const spouseDetailsFormRules = (store, next, action) => {
    const result = next(action);
    const spouseDetailsForm = getSpouseDetailsForm(store.getState());
    const kra = spouseDetailsForm.tinNumber.value
    const spouseDetailsFormValid = kra === null || kra.length > 0 ? validateSpouseDetailsFormDetailsWithKRA(spouseDetailsForm) : validateSpouseDetailsFormDetails(spouseDetailsForm);
    const formAction = spouseDetailsFormValid
        ? transitionPersonalAccidentSpouseDetailsForm.formValid()
        : transitionPersonalAccidentSpouseDetailsForm.formInvalid();
    store.dispatch(formAction);
    return result;
};

const validateSpouseDetailsFormDetails = formFields => {
    return (
        formFields.firstName &&
        formFields.firstName.status === FIELD_STATUS.VALID &&
        formFields.gender &&
        formFields.gender.status === FIELD_STATUS.VALID &&
        formFields.maritalStatus &&
        formFields.maritalStatus.status === FIELD_STATUS.VALID &&
        formFields.nihfNumber &&
        formFields.nihfNumber.status === FIELD_STATUS.VALID &&
        formFields.dob &&
        formFields.dob.status === FIELD_STATUS.VALID &&
        formFields.phoneNumber &&
        formFields.phoneNumber.status === FIELD_STATUS.VALID &&
        formFields.streetAddress &&
        formFields.streetAddress.status === FIELD_STATUS.VALID &&
        formFields.suburb &&
        formFields.suburb.status === FIELD_STATUS.VALID &&
        formFields.city &&
        formFields.city.status === FIELD_STATUS.VALID &&
        formFields.postalAddress &&
        formFields.postalAddress.status === FIELD_STATUS.VALID
    );
};

const validateSpouseDetailsFormDetailsWithKRA = formFields => {
    return (
        formFields.firstName &&
        formFields.firstName.status === FIELD_STATUS.VALID &&
        formFields.gender &&
        formFields.gender.status === FIELD_STATUS.VALID &&
        formFields.maritalStatus &&
        formFields.maritalStatus.status === FIELD_STATUS.VALID &&
        formFields.nihfNumber &&
        formFields.nihfNumber.status === FIELD_STATUS.VALID &&
        formFields.dob &&
        formFields.dob.status === FIELD_STATUS.VALID &&
        formFields.phoneNumber &&
        formFields.phoneNumber.status === FIELD_STATUS.VALID &&
        formFields.streetAddress &&
        formFields.streetAddress.status === FIELD_STATUS.VALID &&
        formFields.suburb &&
        formFields.suburb.status === FIELD_STATUS.VALID &&
        formFields.city &&
        formFields.city.status === FIELD_STATUS.VALID &&
        formFields.tinNumber &&
        formFields.tinNumber.status === FIELD_STATUS.VALID &&
        formFields.postalAddress &&
        formFields.postalAddress.status === FIELD_STATUS.VALID
    );
};
